import { FilterOptionKeys } from '@griply/types';
import { TFunction } from 'i18next';
import { Repeat } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { TaskType } from 'shared/types/task-base';

export type Options = {
  t: TFunction;
};

export const createTypeFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.Type,
  label: t('context-menus.filtering.task.filters.type.title'),
  placeholder: t('general.labels.select'),
  icon: Repeat,
  type: FilterOptionType.MultiSelect,
  selectOptions: [
    {
      label: t('context-menus.filtering.task.filters.type.options.task'),
      value: TaskType.Task,
    },
    {
      label: t('context-menus.filtering.task.filters.type.options.repeating'),
      value: TaskType.Repeating,
    },
    {
      label: t('context-menus.filtering.task.filters.type.options.habit'),
      value: TaskType.Habit,
    },
  ],
  canReset: true,
});
